// Safely convert a 3- or 6-digit hex color to an {r, g, b} object
const parseHexColor = (hex) => {
  // Remove '#' if present
  let sanitizedHex = hex.replace(/^#/, "");

  // If it's a 3-digit hex, expand it to 6 digits
  if (sanitizedHex.length === 3) {
    sanitizedHex = [...sanitizedHex].map((char) => char + char).join("");
  }

  // Parse the r, g, b values
  const r = parseInt(sanitizedHex.slice(0, 2), 16);
  const g = parseInt(sanitizedHex.slice(2, 4), 16);
  const b = parseInt(sanitizedHex.slice(4, 6), 16);

  return { r, g, b };
};

export const hexToRgba = (hexColor, alpha = 1) => {
  // Normalize and parse
  const { r, g, b } = parseHexColor(hexColor);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Color map
const colorMap = {
  "#FC9E11": {
    fontColor: "#BF7300", // 100% for text
    backgroundColor: hexToRgba("#FC9E11", 0.2), // 20% opacity
  },
  "#049F2F": {
    fontColor: "#004C15",
    backgroundColor: hexToRgba("#049F2F", 0.2),
  },
  // Add more mappings if needed...
};

// Color mapper
export const mapColor = (backendColor) => {
  const colorKey = backendColor.toUpperCase();

  // Fallback: if color not in map, just use the original color at 100% & 20%
  if (!colorMap[colorKey]) {
    return {
      fontColor: colorKey,
      backgroundColor: hexToRgba(colorKey, 0.2),
    };
  }

  return colorMap[colorKey];
};
